import React, { useEffect, useMemo, useRef, useState } from "react";
import "./news.css";
import {
  Sidebar,
  SideBar,
  SidebarLeft,
  SidebarRight,
} from "../layouts/layout1";
import NewSummary from "../newSummary/newSummary";
import v4 from "uuid";
import FaSpinner from "../faSpinner/faSpinner";
import SectionStart from "../sectionStart/sectionStart";
import NewsHeader from "../newsHeader/newsHeader";
import { useNews } from "./newsProvider";
import Button from "../button/button";
import { useDispatch } from "react-redux";
import { setPageTitle, clearPageTitle } from "../../actions/pageTitle";

// The home page block lists only the newest posts, as the old portal did (one page of 5);
// "VIEW ALL BLOGS" in its header leads to the full list.
const BLOCK_VIEW_COUNT = 5;

const News = (props) => {
  const { viewStyle } = props;
  const isBlock = viewStyle === "block";
  const { articles, searchTerm, loading } = useNews();
  const allItems = useMemo(() => articles?.data || [], [articles]);
  const [renderCount, setRenderCount] = useState(20);
  const increment = 20;
  const hasMore = !isBlock && renderCount < allItems.length;
  const loadMoreRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle("BLOG"));
    return () => {
      dispatch(clearPageTitle());
    };
  }, [dispatch]);

  const loadMore = () => {
    setRenderCount((c) => Math.min(c + increment, allItems.length));
  };

  useEffect(() => {
    setRenderCount(20);
  }, [allItems.length, searchTerm]);

  useEffect(() => {
    const el = loadMoreRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting && hasMore && !loading) {
            loadMore();
          }
        });
      },
      { rootMargin: "200px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, loading]);

  let noResults = (!articles || (articles.data || []).length === 0) && !loading;

  return (
    <>
      <SectionStart noDivider>
        <SideBar className="blog-split">
          <SidebarLeft>
            <NewsHeader viewStyle={viewStyle} />
          </SidebarLeft>
          <SidebarRight>
            <div className="nbg-hub-news-wrapper" style={{ minHeight: 570 }}>
              {allItems
                .slice(0, isBlock ? BLOCK_VIEW_COUNT : renderCount)
                .map((node) => (
                  <NewSummary key={v4()} {...node} searchText={searchTerm} />
                ))}
              {noResults && <div> No Results </div>}
              <FaSpinner loading={loading} />
              {/* Pagination removed: rendering full list */}
              <div ref={loadMoreRef} />
              {hasMore && !loading && (
                <div style={{ textAlign: "center", marginTop: 16 }}>
                  <Button className="simple_btn" onClick={loadMore}>
                    Load more
                  </Button>
                </div>
              )}
            </div>
          </SidebarRight>
        </SideBar>
      </SectionStart>
    </>
  );
};

export default News;
